import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 83935 86811"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#fefefe;stroke-width:957.235}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528315467504">
        <path
          d="M61480 18999c-1968 556-3978 1039-6026 1453v28395c1975-48 3505 864 4303 2805 51 125 75 256 75 384h4v6130c280-207 529-419 745-638 452-458 757-939 899-1444V18999zM69541 16166c-1959 839-3977 1579-6027 2225v45636c1975-48 3505 864 4303 2805 51 125 76 256 76 384h3v6131c280-208 529-420 745-639 453-458 759-938 900-1444V16166zM79082 10916c-2381 1655-4889 3091-7507 4333v59450c2344-118 4162 899 5107 3198 53 126 76 256 76 385h4v7619c462-318 863-647 1200-987 568-573 947-1177 1120-1818V10916zM6589 12070v71026c174 641 554 1245 1120 1818 337 340 739 669 1201 987v-7619h3c0-129 25-260 76-385 946-2299 2763-3316 5108-3198V16037c-2610-1135-5118-2449-7508-3967zM24191 19468v36616c142 506 447 986 899 1444 218 219 466 431 745 638v-6129h4c0-129 24-260 75-385 799-1940 2328-2853 4303-2805V20787c-2044-374-4055-811-6026-1319zM16131 16878v54386c142 506 447 987 899 1444 217 219 465 431 745 640v-6131h4c0-128 24-258 76-385 797-1940 2327-2852 4302-2805V18914c-2045-588-4052-1262-6026-2036zM15415 14400c64 20 127 46 185 78 1434 602 2899 1149 4394 1647 1103 367 2222 707 3357 1021 65 11 128 29 188 53 2529 695 5133 1264 7800 1727 46 5 91 13 137 24 3404 587 6910 1002 10492 1286 4183-331 8262-843 12199-1596 50-14 104-24 158-30 2664-515 5263-1144 7782-1904 62-26 127-45 194-59 551-167 1098-341 1642-522 2094-697 4132-1494 6107-2398 53-32 108-57 167-78 3251-1504 6327-3309 9193-5469 48-44 100-82 155-118 921-699 1820-1435 2696-2211 717-634 1133-1574 1189-2506 64-1039-313-2030-1275-2525-756-389-1875-483-3418-84-6108 2823-12229 4673-18361 5815-6138 1142-12282 1573-18428 1560-6147 13-12291-418-18429-1560C17407 5409 11285 3559 5177 736c-1542-399-2661-305-3417 84C798 1315 422 2306 485 3345c56 932 472 1872 1190 2506 4078 3608 8721 6423 13740 8549z"
          className="fill"
          style={{
            strokeWidth: 957.235,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
